var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"rounded-lg mt-4",attrs:{"footer-class":"p-0"}},[(_vm.settingLoaded)?_c('staff-details-form'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }